module.exports = __webpack_public_path__ + "img/io-2.72f8c73e.png";